
const baseFormValidation = require('base/components/formValidation');

/**
 * Custom form validation with support for error titles
 * @param {element} formElement - Form element to validate
 * @param {Object} payload - Validation payload
 * @returns {void}
 */
module.exports = function (formElement, payload) {
    // Call base form validation first
    baseFormValidation(formElement, payload);

    // Remove the standard error alert
    $('.alert', formElement).remove();
    
    // Override error display for account locked errors
    if (payload && payload.error) {
        // Create custom error with title
        var form = $(formElement).prop('tagName') === 'FORM'
            ? $(formElement)
            : $(formElement).parents('form');
            
        if (payload.errorType === 'account_locked') {
            var errorHtml = '<div class="mk-login-alert-unsuccess alert alert-error alert-error--bg-surfacecritical p-3 mb-4 border-0 mk-rounded-3" role="alert">';
            errorHtml += '<div class="title error-title font-weight-xbold mb-1 small">'+ payload.errorTitle + '</div>';
            errorHtml += '<div class="error-message small m-0">' + payload.error.join('<br/>') + '</div>';
            errorHtml += '</div>';
            
            form.prepend(errorHtml);
        } else {
            const addressValidationError = $('.js-address-validation-error');
            if(addressValidationError.length > 0 && form.parents().find('.js-address-validation-error').length > 0) {
                addressValidationError.removeClass('d-none');    
                addressValidationError.empty().append(payload.error[0]);
            }
            form.prepend('<div class="alert alert-error alert-error--bg-surfacecritical p-3 mk-rounded-3 mb-4" role="alert"> '
            + payload.error.join('<br/>') + '</div>');
        }        
    }  
};
